import styled, { css } from 'styled-components'

type Props = {
  title: string
  count: string | number
  percentage: React.ReactNode
  percentageValue: number
}

export const AvgBuyMcDistributionTitle = (props: Props) => {
  return <Title>{props.title}</Title>
}
export const AvgBuyMcDistributionTrack = (props: Props) => {
  const isZero = props.percentageValue === 0
  const isFull = props.percentageValue === 100
  let status: State = 'normal'
  if (isZero) {
    status = 'zero'
  } else if (isFull) {
    status = 'full'
  }

  return (
    <Track>
      <Fill
        $height={status === 'zero' ? 100 : props.percentageValue}
        $state={status}
      />
      <TrackInfo $status={status}>
        <TrackCount>{props.count}</TrackCount>
        <TrackPercentage $status={status}>{props.percentage}</TrackPercentage>
      </TrackInfo>
    </Track>
  )
}

const Title = styled.div`
  color: var(--text-10);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
`
type State = 'zero' | 'full' | 'normal'
const colorMap: Record<State, string> = {
  zero: 'var(--background-6)',
  full: 'var(--background-12)',
  normal: 'var(--background-12)',
}
const TrackInfo = styled.div<{ $status: State }>`
  color: ${({ $status }) => colorMap[$status]};
  text-align: center;
  position: relative;

  font-size: 13px;
  font-weight: 600;
  padding: 12px 4px;
`
const Track = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: var(--appearanceA-5, var(--appearanceA-5));
`
const Fill = styled.div<{
  $height: number
  $state: State
}>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${({ $height }) => $height}%;

  ${({ $state }) => {
    if ($state === 'zero') {
      return css`
        background: repeating-linear-gradient(
          -45deg,
          rgba(var(--background-6-rgb), 0.1),
          rgba(var(--background-6-rgb), 0.1) 10px,
          transparent 10px,
          transparent 20px
        );
      `
    } else if ($state === 'full') {
      return css`
        border-radius: 8px;
        border: 1px solid var(--up-11);
        background: var(--up-4);
      `
    } else {
      return css`
        border-radius: 0 0 8px 8px;
        background: var(--up-4);
        border: 1px solid var(--up-7);
        border-top-color: var(--up-11);
      `
    }
  }}
`
const TrackCount = styled.div``

const percentageColorMap: Record<State, string> = {
  zero: 'inherit',
  full: 'var(--up-11)',
  normal: 'inherit',
}
const TrackPercentage = styled.div<{ $status: State }>`
  color: ${({ $status }) => percentageColorMap[$status]};
`
